/* eslint-disable no-param-reassign */
/* eslint-disable import/no-extraneous-dependencies */
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'connected-react-router';
import rootReducer, { createReducer } from './reducers';
import { httpMiddleware } from './reducers/helper/reduxActionHelper';

export const history = createBrowserHistory();

const reduxRouterMiddleware = routerMiddleware(history);
const devTool = window.__REDUX_DEVTOOLS_EXTENSION__
  ? window.__REDUX_DEVTOOLS_EXTENSION__()
  : (f) => f;
const configureStore = () => {
  const store = createStore(
    rootReducer,
    compose(
      applyMiddleware(thunk, reduxRouterMiddleware, httpMiddleware),
      process.env.REACT_APP_ENV === 'development' ? devTool : (f) => f,
    ),
  );
  store.asyncReducers = {};
  return store;
};
export const injectAsyncReducer = (store, name, asyncReducer) => {
  if (!store.asyncReducers[name]) {
    // store.asyncReducers[name] = asyncReducer.default;
  } else {
    // store.asyncReducers = {};
    // store.asyncReducers[name] = asyncReducer.default;
  }
  store.asyncReducers[name] = asyncReducer.default;
  store.replaceReducer(createReducer(store.asyncReducers));
};

// let store = createStore(
//     rootReducer,
//     compose(
//         applyMiddleware(thunk,reduxRouterMiddleware,sagaMiddleware),
//         window.devToolsExtension ? window.devToolsExtension() : f => f
//     )
// );

// export default store;
export default configureStore();
